import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconReport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5625 0C6 0 5.625 0.375 5.625 0.9375V1.96875C2.4375 2.4375 0 5.15625 0 8.4375C0 12.0938 2.90625 15 6.5625 15C8.4375 15 10.125 14.25 11.25 12.9375L12.0938 13.5C12.6562 13.875 13.2188 13.5 13.4062 13.3125C14.4375 11.9062 15 10.2188 15 8.4375C15 3.75 11.25 0 6.5625 0ZM6.5625 13.125C3.9375 13.125 1.875 11.0625 1.875 8.4375C1.875 6.1875 3.46875 4.3125 5.625 3.84375V8.4375C5.625 8.71875 5.8125 9 6 9.1875L9.75 11.8125C8.90625 12.6562 7.78125 13.125 6.5625 13.125Z",
		fill: "currentColor"
	})
});
export default SvgIconReport;
